import { render } from "./iot.vue?vue&type=template&id=80a3c40c"
import script from "./iot.vue?vue&type=script&lang=js"
export * from "./iot.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__